import { render, staticRenderFns } from "./dropshipForm.vue?vue&type=template&id=73df864a"
import script from "./dropshipForm.vue?vue&type=script&lang=js"
export * from "./dropshipForm.vue?vue&type=script&lang=js"
import style0 from "./dropshipForm.vue?vue&type=style&index=0&id=73df864a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports